/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../../../app/modules/auth'
import { Languages } from './Languages'
import { KTIcon, toAbsoluteUrl } from '../../../helpers';
import { useAppSelector, useAppDispatch } from '../../../../app/hooks'
import { logOut } from '../../../../common/auth/Auth'
import { MultiFactorAuthentication } from '../../../../features/multifactorauthentication/MultiFactorAuthentication';
import { UncheckedshowAdminPagesState } from '../../../../common/GlobalSlice';
import { getValueFromResource } from '../../../../common/timeLiveFunction';
import { useTranslation } from 'react-i18next';
import { EmployeeIntegrationModal } from '../../../../features/admin/integrations/EmployeeIntegerationModal';
import { Integration } from '../../../../features/admin/integrations/Integration';
import MultiFactorModal from '../../../../features/multifactorauthentication/MultiFactorModal';
import { getEmployeeProfileAsync } from '../../../../features/profile/ProfileSlice';

const HeaderUserMenu: FC = () => {
  const modelRef = useRef<any>(null);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { currentUser, logout } = useAuth()
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isModalOpenInt, setIsModalOpenInt] = useState<boolean>(false);
  const navigate = useNavigate();
  // const { accountId, accountEmployeeId, isUserImage, profilePictureColor, employeeName, shortName } = useAppSelector((state) => state.timesheet);
  const { sessionAccountId, sessionAccountEmployeeId, profilePictureColor, shortName, showEmployeeProfilePicture, emailAddress, employeeName, profileURL, AccountIdsForGoogleCalendar, AccountIdsForOutlookCalendar } = useAppSelector((state) => state.globalState);
  const { isReload } = useAppSelector((state) => state.profile);
  // console.log('showEmployeeProfilePicture',showEmployeeProfilePicture)
  // console.log('profileURL',profileURL)
  const licenseExpireFlag = localStorage.getItem("IsLicenseExpired");
  const IsFreeLicenseExpired = localStorage.getItem("IsFreeLicenseExpired");
  const expireFalg = (licenseExpireFlag === "true" || IsFreeLicenseExpired === "true");


  const handleOnClickEvent = () => {
    setIsModalOpen(true);
  }

  const openModal = () => {
    setIsModalOpen(true);
  }

  const closeModal = () => {
    setIsModalOpen(false);
  }

  const openModalInt = (e: any) => {
    e.preventDefault();
    setIsModalOpenInt(true);
  }

  const closeModalInt = () => {
    setIsModalOpenInt(false);
  }

  const handleLinkClick = () => {
    localStorage.setItem('objAdmin', JSON.stringify(false));
    dispatch(UncheckedshowAdminPagesState());
  }

  const navigateToIntegration = () => {
    if (expireFalg) {
      navigate('/expiry')
    } else {
      navigate("/employeeIntegrations");
    }
  };


  return (
    <>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold pb-0 fs-6 w-265px'
        data-kt-menu='true'
      >
        {/* <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-35px'>
            {showEmployeeProfilePicture ? <img alt='Logo' src={toAbsoluteUrl(`${window.origin}/Uploads/${sessionAccountId}/${sessionAccountEmployeeId}/Profile/E-Profile.gif`)} /> :
              <div className='symbol-label' style={{ backgroundColor: profilePictureColor, borderRadius:'55%' }}>
                <span className='text-white'>{shortName}</span>
              </div>
            }
          </div>
          <div className='d-flex flex-column'>
            <span className='text-gray-600 px-2 fs-3'>
              {employeeName}
            </span>
          </div>
          <div className='d-flex flex-column'>
            <a href='#' className='text-gray-600 px-5 fs-7'>
              {emailAddress}
            </a>
          </div>
          </div>
        </div> */}
        <div className='menu-item px-3'>
          <div className='d-flex align-items-center px-2'>
            {/* Profile Picture */}
            <div className='symbol symbol-50px me-2'>
              {showEmployeeProfilePicture && profileURL ?
                <img
                  // src={profileURL}
                  src={`${profileURL}?${new Date().getTime()}`}
                  className='tsReportIcon' style={{
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px'
                  }} />
                : (
                  <div
                    className='symbol-label d-flex justify-content-center align-items-center me-1'
                    style={{
                      backgroundColor: profilePictureColor,
                      borderRadius: '50%',
                      width: '50px',
                      height: '50px'

                    }}
                  >

                    <span className='text-white fs-2'>{shortName}</span>
                  </div>)
              }
              {/* {showEmployeeProfilePicture ? (
                <img
                  alt='Profile'
                  src={toAbsoluteUrl(
                    `${window.origin}/Uploads/${sessionAccountId}/${sessionAccountEmployeeId}/Profile/E-Profile.gif`
                  )}
                  style={{ borderRadius: '50%' }}
                />
              ) : (
                <div
                  className='symbol-label d-flex justify-content-center align-items-center me-1'
                  style={{
                    backgroundColor: profilePictureColor,
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px'
                  
                  }}
                >
                 
                  <span className='text-white fs-2'>{shortName}</span>
                </div>
              )} */}
            </div>
            {/* Name and Email */}
            <div className='d-flex flex-column align-items-start'>
              <span className='text-gray-700 fw-bold fs-3'>{employeeName}</span>
              <a className='menu-text user-profile profile-font fs-7'>
                {localStorage.getItem('userEmailAddress')}
                {/* {emailAddress} */}
              </a>
              <span className='menu-text user-profile profile-font fs-7'>
                {localStorage.getItem('userRole')}
              </span>
            </div>
          </div>
        </div>
        {/* <div className='menu-item px-5'>
        <Link to='/profile' className='menu-link px-0'>
          <span className="symbol-label">
            <i className="ki-outline bi bi-person text-gray-800 fs-6"></i>
          </span>
          <span className='menu-text' style={{ marginLeft: 6, marginBottom: 0 }}>My Profile</span>
        </Link>
      </div> */}
        <div className='separator my-2'></div>
        <div className='menu-item px-2'>
          <div className='menuPro-hover-bg-sec'>
            <Link to={expireFalg ? '/expiry' : '/profile'} onClick={handleLinkClick} className='menu-link px-4'>
              {/* <i className="ki-outline bi bi-person fs-3 iconColor"></i> */}
              <i className="ki-duotone ki-user fs-3 top-50 translate" style={{ marginRight: '7px' }}>
                <span className="path1"></span>
                <span className="path2"></span>
              </i>
              <span className='menu-title profile-font' style={{ marginLeft: -2, marginBottom: 1, paddingTop: 2 }}>
                {getValueFromResource('Profile', dispatch, t)}
              </span>
            </Link>
          </div>
        </div>
        {/* <div className='menu-item px-5'>
        <Link to='/employeeEmailPreferences' className='menu-link px-0'>
          <span className="symbol-label">
            <i className="ki-outline bi bi-envelope text-gray-800 fs-6"></i>
          </span>
          <span className='menu-text' style={{ marginLeft: 6, marginBottom: 0 }}>My Email Preferences</span>
        </Link>
      </div> */}
        <div className='menu-item px-2'>
          <div className='menuPro-hover-bg-sec'>
            <Link to={expireFalg ? '/expiry' : '/employeeEmailPreferences'} className='menu-link px-4'>
              <span className="symbol-label">
                {/* <i className="ki-outline bi bi-envelope fs-4 iconColor"></i> */}
                <i className="ki-duotone ki-notification-status fs-3 top-50 translate" style={{ marginRight: '7px' }}>
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              </span>
              <span className='menu-title profile-font' style={{ marginLeft: -2, marginBottom: 4 }}>
                {/* My Email Preferences */}
                {getValueFromResource('Email Preferences', dispatch, t)}
              </span>
            </Link>
          </div>
        </div>
        {/* <div className='menu-item px-5'>
          <a
            href="#" 
            className='menu-link px-0'
            onClick={(event) => {
              event.preventDefault();
              handleOnClickEvent();
            }}
          >
          <span className="symbol-label">
            <i className="ki-outline bi bi-envelope text-gray-800 fs-6"></i>
          </span>
          <span className='menu-text' style={{ marginLeft: 6, marginBottom: 0 }}>My Security</span>
        </a>
      </div> */}
        <div className='menu-item px-2'>
          <div className='menuPro-hover-bg-sec'>
            <a
              href="#"
              className='menu-link px-4'
              onClick={(event) => {
                event.preventDefault();
                if(expireFalg){
                  navigate('/expiry')
                }else{
                  handleOnClickEvent();
                }
              }}
            >
              <span className="symbol-label">
                {/* <i className="ki-outline bi bi-envelope text-gray-800 fs-6"></i> */}
                {/* <i className="ki-outline bi bi-shield-plus fs-4 iconColor"></i> */}
                <i className="ki-duotone ki-shield-tick fs-2 top-50 translate" style={{ marginRight: '7px' }}>
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              </span>
              <span className='menu-title profile-font' style={{ marginLeft: -2, marginBottom: 3 }}>
                {/* My Security */}
                {getValueFromResource('Security', dispatch, t)}
              </span>
            </a>
          </div>
        </div>
        {(AccountIdsForGoogleCalendar || AccountIdsForGoogleCalendar) &&
          <div className='menu-item px-2'>
            <div className="menuPro-hover-bg-sec">
              <a className="menu-link px-4" onClick={navigateToIntegration}>
                <span className="symbol-label">
                  <i className="ki-duotone ki-technology-4" style={{ marginRight: "10px" }}>
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </i>
                </span>
                <span className="menu-title profile-font" style={{ marginBottom: 3 }}>
                  {getValueFromResource("Integrations", dispatch, t)}
                </span>
              </a>
            </div>

          </div>
        }
        <div className='separator my-2'></div>
        {/* <div className='menu-item px-5'>
        <Link to={'/crafted/pages/profile'} className='menu-link px-5'>
          My Profile
        </Link>
      </div>  */}
        {/* <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          <span className='menu-text'>My Projects</span>
          <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span>
        </a>
      </div>  */}
        {/* <div
        className='menu-item px-5'
        data-kt-menu-trigger='hover'
        data-kt-menu-placement='left-start'
        data-kt-menu-flip='bottom'
      >
        <a href='#' className='menu-link px-5'>
          <span className='menu-title'>My Subscription</span>
          <span className='menu-arrow'></span>
        </a>
        <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Referrals
            </a>
          </div>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Billing
            </a>
          </div>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Payments
            </a>
          </div>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link d-flex flex-stack px-5'>
              Statements
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='View your statements'
              ></i>
            </a>
          </div>
          <div className='separator my-2'></div>
          <div className='menu-item px-3'>
            <div className='menu-content px-3'>
              <label className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input w-30px h-20px'
                  type='checkbox'
                  value='1'
                  defaultChecked={true}
                  name='notifications'
                />
                <span className='form-check-label text-muted fs-7'>Notifications</span>
              </label>
            </div>
          </div>
        </div>
      </div>  */}

        {/* <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          My Statements
        </a> 
      </div>  */}
        {/* <div className='separator my-2'></div>
      <Languages /> */}
        {/* <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          Account Settings
        </Link>
      </div> */}

        <div className='menu-item px-2'>
          <div className='menuPro-hover-bg-danger '>
            <a onClick={() => { logOut() }} className='menu-link px-4'>
              {/* <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span> */}
              <span className="symbol-label">
                {/* <i className="ki-outline bi bi-box-arrow-right fs-4 iconColor"></i> */}
                <i className="ki-duotone ki-exit-right fs-2 top-50 translate pro-signout" style={{ marginRight: '7px' }}>
                  <span className="path1"></span>
                  <span className="path2"></span>
                </i>
              </span>
              <span className='menu-title profile-font delete-menu pro-signout' style={{ marginLeft: -2, marginBottom: 2 }}>
                {/* Sign Out */}
                {getValueFromResource('Sign Out', dispatch, t)}
              </span>
            </a>
          </div>
        </div>
      </div>
      {isModalOpen &&
        // <MultiFactorAuthentication oncloseModal={closeModal} />
        <MultiFactorModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />

      }

      {isModalOpenInt && (
        <EmployeeIntegrationModal modelRef={modelRef}
          oncloseModal={closeModalInt}
          employeeId={sessionAccountEmployeeId}
        />
      )}

    </>
  )
}

export { HeaderUserMenu }